window.MC_SPECS = {
  "boutique-mattress-memory-foam": {
    "title": "Boutique Mattress",
    "feel": "Medium firm",
    "mechanism": "7 zone CrafterCoil pocket springs",
    "confirmed": true,
    "layers": [
      {
        "name": "High density quilted foam fabric",
        "what": "a dense foam quilted into the cover fabric that forms the top surface",
        "does": "keeps the surface even and lets air move through",
        "feel": "The surface feels even underfoot and does not feel stuffy against your skin."
      },
      {
        "name": "Visco memory foam",
        "what": "a slow response viscoelastic memory foam",
        "does": "moulds to your shape and eases pressure at the shoulders and hips",
        "feel": "The surface slowly gives way and cradles your shoulders and hips rather than pushing back."
      },
      {
        "name": "CrafterCore Plus convoluted foam",
        "what": "an egg crate profile convoluted foam sitting under the memory foam",
        "does": "the peaks add cushioning and the channels let air move through the comfort layers",
        "feel": "A softer, airier layer under the memory foam, so the bed does not feel like it holds heat."
      },
      {
        "name": "Supportive firm foam",
        "what": "a firm support foam",
        "does": "keeps the surface stable and level over the spring unit",
        "feel": "You do not feel this layer directly, but the softer layers above do not feel like they sink unevenly."
      },
      {
        "name": "7 zone CrafterCoil pocket system",
        "what": "individually wrapped pocket springs arranged in seven zones",
        "does": "gives firmer support under your hips and softer give under your shoulders to keep your spine aligned, and isolates movement between sides of the bed",
        "feel": "Your spine stays level through the night and a partner moving beside you barely registers."
      }
    ]
  },
  "boutique-deluxe-mattress": {
    "title": "Boutique Deluxe Mattress",
    "feel": "Medium firm",
    "mechanism": "CrafterCool-Ice gel cooling foam over 7 zone CrafterCoil pocket springs",
    "confirmed": true,
    "layers": [
      {
        "name": "High density quilted foam fabric",
        "what": "a dense foam quilted into the cover fabric that forms the top surface",
        "does": "keeps the surface even and lets air move through",
        "feel": "The surface feels even underfoot and does not feel stuffy against your skin."
      },
      {
        "name": "Visco memory foam",
        "what": "a slow response viscoelastic memory foam",
        "does": "moulds to your shape and eases pressure at the shoulders and hips",
        "feel": "The surface slowly gives way and cradles your shoulders and hips rather than pushing back."
      },
      {
        "name": "CrafterCore Plus convoluted foam",
        "what": "an egg crate profile convoluted foam sitting under the memory foam",
        "does": "the peaks add cushioning and the channels let air move through the comfort layers",
        "feel": "A softer, airier layer under the memory foam, so the bed does not feel like it holds heat."
      },
      {
        "name": "Gel infused memory foam",
        "what": "a gel infused memory foam",
        "does": "draws heat away from your body while it contours to your shape",
        "feel": "The pressure relief of memory foam without the overnight warmth build up."
      },
      {
        "name": "Supportive firm foam",
        "what": "a firm support foam",
        "does": "keeps the surface stable and level over the spring unit",
        "feel": "You do not feel this layer directly, but the softer layers above do not feel like they sink unevenly."
      },
      {
        "name": "7 zone CrafterCoil pocket system",
        "what": "individually wrapped pocket springs arranged in seven zones",
        "does": "gives firmer support under your hips and softer give under your shoulders to keep your spine aligned, and isolates movement between sides of the bed",
        "feel": "Your spine stays level through the night and a partner moving beside you barely registers."
      }
    ]
  },
  "luxury-mattress-australia-boutique": {
    "title": "Boutique Deluxe Plus Mattress",
    "feel": "Medium plush",
    "mechanism": "CrafterLastic natural latex over 7 zone CrafterCoil pocket springs",
    "confirmed": true,
    "layers": [
      {
        "name": "High density quilted foam fabric",
        "what": "a dense foam quilted into the cover fabric that forms the top surface",
        "does": "keeps the surface even and lets air move through",
        "feel": "The surface feels even underfoot and does not feel stuffy against your skin."
      },
      {
        "name": "Visco memory foam",
        "what": "a slow response viscoelastic memory foam",
        "does": "moulds to your shape and eases pressure at the shoulders and hips",
        "feel": "The surface slowly gives way and cradles your shoulders and hips rather than pushing back."
      },
      {
        "name": "CrafterCore Plus convoluted foam",
        "what": "an egg crate profile convoluted foam sitting under the memory foam",
        "does": "the peaks add cushioning and the channels let air move through the comfort layers",
        "feel": "A softer, airier layer under the memory foam, so the bed does not feel like it holds heat."
      },
      {
        "name": "SGS certified pure natural latex",
        "what": "an SGS certified natural latex layer",
        "does": "gives a softer, more cushioned feel and springs back with you as you move",
        "feel": "Instead of slowly sinking, the surface gives and then springs back as you shift position."
      },
      {
        "name": "Gel infused memory foam",
        "what": "a gel infused memory foam",
        "does": "draws heat away from your body while it contours to your shape",
        "feel": "The pressure relief of memory foam without the overnight warmth build up."
      },
      {
        "name": "Supportive firm foam",
        "what": "a firm support foam",
        "does": "keeps the surface stable and level over the spring unit",
        "feel": "You do not feel this layer directly, but the softer layers above do not feel like they sink unevenly."
      },
      {
        "name": "7 zone CrafterCoil pocket system",
        "what": "individually wrapped pocket springs arranged in seven zones",
        "does": "gives firmer support under your hips and softer give under your shoulders to keep your spine aligned, and isolates movement between sides of the bed",
        "feel": "Your spine stays level through the night and a partner moving beside you barely registers."
      }
    ]
  },
  "boutique-extra-firm-mattress": {
    "title": "Boutique Extra Firm Mattress",
    "feel": "Firm",
    "mechanism": "Heavy duty 2.4mm 7 zone pocket springs with reinforced edge",
    "confirmed": true,
    "layers": [
      {
        "name": "High density quilted foam fabric",
        "what": "a dense foam quilted into the cover fabric that forms the top surface",
        "does": "keeps the surface even and lets air move through",
        "feel": "The surface feels even underfoot and does not feel stuffy against your skin."
      },
      {
        "name": "Visco memory foam",
        "what": "a slow response viscoelastic memory foam",
        "does": "moulds to your shape and eases pressure at the shoulders and hips",
        "feel": "The surface slowly gives way and cradles your shoulders and hips rather than pushing back."
      },
      {
        "name": "CrafterCore Plus convoluted foam",
        "what": "an egg crate profile convoluted foam sitting under the memory foam",
        "does": "the peaks add cushioning and the channels let air move through the comfort layers",
        "feel": "A softer, airier layer under the memory foam, so the bed does not feel like it holds heat."
      },
      {
        "name": "Extra firm foam",
        "what": "a firm, dense support foam",
        "does": "keeps the surface stable and level, and is the layer that sets the extra firm feel",
        "feel": "You rest on top of the surface rather than sinking into it."
      },
      {
        "name": "2.4mm CrafterCoil pocket system",
        "what": "a heavy duty 2.4mm twice tempered pocket spring core arranged in seven zones",
        "does": "the thicker wire holds firm support for longer, and each spring is wrapped on its own to isolate movement",
        "feel": "Strong, stable support with minimal disturbance if someone else moves on the bed."
      }
    ]
  },
  "boutique-craft-cell-mattress": {
    "title": "Boutique Craft Cell Mattress",
    "feel": "Medium firm",
    "mechanism": "All foam, CrafterCore Plus over HD zoned foam with CrafterEdge perimeter, no springs",
    "confirmed": true,
    "layers": [
      {
        "name": "Gel infused memory foam",
        "what": "a gel infused memory foam",
        "does": "draws heat away from your body while it contours to your shape",
        "feel": "The pressure relief of memory foam without the overnight warmth build up."
      },
      {
        "name": "High density foam",
        "what": "a high density foam",
        "does": "gives the comfort layers a stable, supportive base",
        "feel": "A firmer layer beneath the gel foam that keeps you from sinking too far."
      },
      {
        "name": "CrafterCore Plus zoned HR foam",
        "what": "a high resilience zoned foam base with a CrafterEdge reinforced perimeter",
        "does": "targets support across zones without any springs, and keeps the edges firm",
        "feel": "No spring bounce at all, an even, still surface edge to edge."
      }
    ]
  },
  "hybrid-mattress-australia": {
    "title": "Boutique Craft Cell Hybrid Mattress",
    "feel": "Medium firm",
    "mechanism": "Natural latex over 7 zone CrafterCoil pocket springs in an edge support box",
    "confirmed": true,
    "layers": [
      {
        "name": "SGS certified pure natural latex",
        "what": "an SGS certified natural latex layer",
        "does": "gives a softer, more cushioned feel and springs back with you as you move",
        "feel": "Instead of slowly sinking, the surface gives and then springs back as you shift position."
      },
      {
        "name": "Gel infused memory foam",
        "what": "a gel infused memory foam",
        "does": "draws heat away from your body while it contours to your shape",
        "feel": "The pressure relief of memory foam without the overnight warmth build up."
      },
      {
        "name": "High density foam",
        "what": "a high density foam",
        "does": "gives the comfort layers a stable, supportive base",
        "feel": "A firmer layer that keeps you from sinking too far."
      },
      {
        "name": "7 zone CrafterCoil pocket system",
        "what": "individually wrapped pocket springs arranged in seven zones",
        "does": "gives firmer support under your hips and softer give under your shoulders to keep your spine aligned, and isolates movement between sides of the bed",
        "feel": "Your spine stays level through the night and a partner moving beside you barely registers."
      },
      {
        "name": "Edge supportive foam box",
        "what": "a reinforced foam box built around the spring unit",
        "does": "keeps the edges firm so the full width of the bed is usable",
        "feel": "You can sit or sleep right to the edge without it collapsing under you."
      }
    ]
  },
  "chiro-luxe": {
    "title": "Therapedic Chiro Luxe Mattress",
    "feel": "Medium",
    "mechanism": "TheraCoil honeycomb zoned micro barrel springs",
    "confirmed": false,
    "licensedNote": true,
    "layers": [
      {
        "name": "Quilted cover",
        "what": "a quilted cover, stitched rather than glued flat",
        "does": "keeps the top surface soft without losing the support underneath",
        "feel": "A soft, finished surface that does not feel stiff."
      },
      {
        "name": "Hygroflex orthopedic comfort layers",
        "what": "Hygroflex orthopedic comfort foam, tested for pressure redistribution",
        "does": "redistributes pressure across the body rather than concentrating it at the shoulders and hips",
        "feel": "Pressure points feel eased rather than dug into."
      },
      {
        "name": "TheraCoil honeycomb zoned micro barrel springs",
        "what": "a honeycomb zoned micro barrel spring system, a finer and more complex build than a standard pocket spring",
        "does": "supports your lumbar while letting your shoulders sink",
        "feel": "Your lower back feels held while your shoulders settle in."
      },
      {
        "name": "Pro-Box edge support",
        "what": "reinforced foam running around the mattress perimeter",
        "does": "holds your weight at the edge instead of collapsing",
        "feel": "You can sit or sleep at the very edge of the bed without it giving way."
      }
    ]
  },
  "exquisite-signature-mattress": {
    "title": "Therapedic Exquisite Signature Mattress",
    "feel": "Medium",
    "mechanism": "TheraCoil honeycomb zoned micro barrel springs",
    "confirmed": false,
    "licensedNote": true,
    "layers": [
      {
        "name": "Sense-Ice cooling fabric cover",
        "what": "a Sense-Ice cooling fabric cover, engineered to wick heat and moisture",
        "does": "wicks heat and moisture away from your body rather than just feeling cool on contact",
        "feel": "The surface stays cool to the touch through the night rather than warming up."
      },
      {
        "name": "Copper Gel layer",
        "what": "a copper infused gel comfort layer",
        "does": "copper is naturally antimicrobial, which keeps the layer cleaner over years of use",
        "feel": "You do not feel this layer directly, it is a durability and hygiene benefit that lasts over years of use."
      },
      {
        "name": "Graphene Visco Elastic cooling foam",
        "what": "a graphene visco elastic memory foam",
        "does": "conducts heat away from your body instead of trapping it the way ordinary memory foam does",
        "feel": "The contouring feel of memory foam without the warmth that usually comes with it."
      },
      {
        "name": "Hygroflex orthopedic comfort layer",
        "what": "Hygroflex orthopedic comfort foam, tested for pressure redistribution",
        "does": "redistributes pressure across the body rather than concentrating it at the shoulders and hips",
        "feel": "Pressure points feel eased rather than dug into."
      },
      {
        "name": "TheraCoil honeycomb zoned micro barrel springs",
        "what": "a honeycomb zoned micro barrel spring system, a finer and more complex build than a standard pocket spring",
        "does": "supports your lumbar while letting your shoulders sink",
        "feel": "Your lower back feels held while your shoulders settle in."
      },
      {
        "name": "Pro-Box edge support",
        "what": "reinforced foam running around the mattress perimeter",
        "does": "holds your weight at the edge instead of collapsing",
        "feel": "You can sit or sleep at the very edge of the bed without it giving way."
      }
    ]
  },
  "exquisite-premier-mattress": {
    "title": "Therapedic Exquisite Premier Mattress",
    "feel": "Medium",
    "mechanism": "TheraCoil honeycomb zoned micro barrel springs",
    "confirmed": false,
    "licensedNote": true,
    "layers": [
      {
        "name": "Sense-Ice cooling fabric cover",
        "what": "a Sense-Ice cooling fabric cover, engineered to wick heat and moisture",
        "does": "wicks heat and moisture away rather than just feeling cool to the touch for the first few minutes",
        "feel": "The surface stays cool to the touch through the night rather than warming up."
      },
      {
        "name": "Viscool visco elastic foam",
        "what": "Viscool visco elastic memory foam",
        "does": "gives the pressure relief of memory foam without running as warm as standard foam",
        "feel": "Contouring pressure relief without the trapped heat."
      },
      {
        "name": "Natural latex comfort layer",
        "what": "a natural latex comfort layer",
        "does": "gives a durable, responsive top layer that keeps its feel over years of use",
        "feel": "A springy, responsive surface rather than the slow sink of synthetic foam."
      },
      {
        "name": "TheraCoil honeycomb zoned micro barrel springs",
        "what": "a honeycomb zoned micro barrel spring system, a finer and more complex build than a standard pocket spring",
        "does": "supports your lumbar while letting your shoulders sink",
        "feel": "Your lower back feels held while your shoulders settle in."
      },
      {
        "name": "Pro-Box edge support",
        "what": "reinforced foam running around the mattress perimeter",
        "does": "holds your weight at the edge instead of collapsing",
        "feel": "You can sit or sleep at the very edge of the bed without it giving way."
      }
    ]
  },
  "elevate-essential-mattress": {
    "title": "Therapedic Elevate Essential Mattress",
    "feel": "Medium",
    "mechanism": "TheraSeven zoned support system",
    "confirmed": false,
    "licensedNote": true,
    "layers": [
      {
        "name": "Quilted cover",
        "what": "a quilted cover, stitched to the same standard as the rest of the range",
        "does": "keeps the surface finished rather than left as a simple wrap",
        "feel": "A soft, finished top surface."
      },
      {
        "name": "High density comfort layers",
        "what": "a high density comfort foam",
        "does": "holds its shape for years rather than softening within months",
        "feel": "The surface support stays consistent instead of drooping over time."
      },
      {
        "name": "High density comfort layers",
        "what": "a second high density foam layer beneath the comfort layer above",
        "does": "adds a further stable base before the support springs",
        "feel": "Extra stability underfoot before you reach the spring layer."
      },
      {
        "name": "TheraSeven zoned support springs",
        "what": "a TheraSeven zoned support spring system, seven zones running under the spine",
        "does": "keeps your hips from sinking further than your shoulders do",
        "feel": "Your spine stays level regardless of sleeping position."
      }
    ]
  },
  "resort": {
    "title": "Resort Mattress",
    "feel": "Medium firm",
    "mechanism": "CrafterCoil 2.2 twice tempered 7 zone pocket coil",
    "confirmed": true,
    "layers": [
      {
        "name": "Sensor-Top quilted cover",
        "what": "a breathable Sensor-Top knit cover fabric",
        "does": "lets air move through the surface",
        "feel": "The bed feels fresh against your skin instead of trapping heat."
      },
      {
        "name": "CrafterCore-HD high density foam",
        "what": "a high density CrafterCore-HD comfort foam",
        "does": "contours gently to the body while maintaining a supportive surface",
        "feel": "A medium firm give, contouring without losing support underneath."
      },
      {
        "name": "CrafterCoil 2.2 twice tempered 7 zone pocket coil",
        "what": "individually wrapped, twice tempered pocket springs arranged in seven zones",
        "does": "each spring responds independently to movement, keeping spinal alignment and reducing partner disturbance",
        "feel": "Your side of the bed stays steady even if someone else moves on theirs."
      }
    ]
  },
  "superior": {
    "title": "Superior Mattress",
    "feel": "Medium firm",
    "mechanism": "CrafterCool-Ice gel over 7 zone CrafterCoil pocket springs",
    "confirmed": true,
    "layers": [
      {
        "name": "Sensor-Top quilted cover",
        "what": "a breathable Sensor-Top knit cover fabric",
        "does": "lets air move through the surface",
        "feel": "The bed feels fresh against your skin instead of trapping heat."
      },
      {
        "name": "CrafterCool-Ice advanced gel foam",
        "what": "a CrafterCool-Ice advanced gel infused foam",
        "does": "sits at the surface providing cooling comfort and pressure relief through the night",
        "feel": "The surface feels cool rather than warming up as the night goes on."
      },
      {
        "name": "CrafterCoil twice tempered 7 zone pocket coil",
        "what": "a twice tempered pocket coil core arranged in seven zones",
        "does": "delivers responsive support and keeps your spine aligned while limiting partner disturbance",
        "feel": "Consistent support across the bed with minimal movement transfer."
      }
    ]
  },
  "retreat": {
    "title": "Retreat Mattress",
    "feel": "Firm",
    "mechanism": "Concave-Coil spring unit in a 17cm profile",
    "confirmed": true,
    "layers": [
      {
        "name": "Quilted cover",
        "what": "a quilted cover over the comfort layer",
        "does": "keeps the surface even and breathable",
        "feel": "An even, breathable surface despite the low profile."
      },
      {
        "name": "High density foam comfort layer",
        "what": "a high density comfort foam",
        "does": "gives a firmer, stable surface",
        "feel": "A firm, supportive feel underfoot rather than a plush sink."
      },
      {
        "name": "Concave-Coil spring unit",
        "what": "an open steel coil spring unit made of interconnected wire coils (not pocket springs, not foam)",
        "does": "gives consistent support across the whole surface and keeps air moving through the mattress",
        "feel": "Firm, even support with airflow, distinct from the springy give of a pocket spring bed."
      }
    ]
  },
  "4-play-mattress": {
    "title": "4 Play Mattress",
    "feel": "Adjustable",
    "mechanism": "Zip top comfort panels over CrafterCoil twice tempered 7 zone pocket springs",
    "confirmed": false,
    "layers": [
      {
        "name": "Zip top comfort panels, one per side",
        "what": "a zip top comfort panel on each side of the mattress, sold as a set of four firmness combinations",
        "does": "lets each side of the bed be set to its own firmness by zipping in a different panel",
        "feel": "You and a partner can each choose a different firmness on your own side."
      },
      {
        "name": "CrafterCoil twice tempered 7 zone pocket springs",
        "what": "individually wrapped pocket springs, twice tempered, arranged in seven zones",
        "does": "holds spring tension for longer and keeps support consistent under each side while the panel on top changes the feel",
        "feel": "The base support stays steady no matter which firmness panel you choose on top."
      }
    ]
  },
  "grandeur": {
    "title": "Grandeur Mattress",
    "feel": "Medium firm",
    "mechanism": "CrafterLastic natural latex over 7 zone CrafterCoil pocket springs",
    "confirmed": true,
    "layers": [
      {
        "name": "Sensor-Top cover",
        "what": "a breathable Sensor-Top knit cover fabric",
        "does": "lets air move through the surface",
        "feel": "The bed feels fresh against your skin instead of trapping heat."
      },
      {
        "name": "CrafterLastic natural latex",
        "what": "SGS certified natural latex harvested from rubber trees",
        "does": "moves with you rather than trapping you, stays breathable and resists dust mites",
        "feel": "A responsive surface that suits hot sleepers and allergy sufferers."
      },
      {
        "name": "CrafterCoil twice tempered 7 zone pocket coil",
        "what": "individually wrapped, twice tempered pocket springs arranged in seven zones",
        "does": "gives firmer resistance under your hips and gentler cushioning under your shoulders, keeping your spine aligned",
        "feel": "Your spine stays level and a partner’s movement barely transfers to your side."
      }
    ]
  }
};
